import Provider from "flexbiz-core/components/auth/NotificationProvider";
class NotifyProvider extends Provider{
    /*openNotify(noti){

    }*/
    async openDetailNotify(code,noti,history){
        switch(code) {
            case "hd2":{
                let v = await this.context.apis.asyncGetData(this.context.userInfo.token,"hd2",{_id:noti.exfields._id});
                if(v){
                    switch(v.trang_thai){
                        case "DH0":
                            history.push(`/voucher/goihangsi?`);
                            break;
                        case "DH1":
                        case "DH2":
                        case "DH3":
                        case "DH4":
                            history.push(`/voucher/goihangsi?` + '?_id=' + noti.exfields._id);
                            break;
                        case "DH5":
                        case "GH0":
                            history.push(`/voucher/giaohangsi?`);
                            break;
                        case "GH1":
                        case "GH2":
                        case "GH3":
                        case "GH4":
                        case "GH5":
                            history.push(`/voucher/giaohangsi?` + '?_id=' + noti.exfields._id);
                            break;
                        default:
                            history.push('/voucher/' + code.toLowerCase() + '?_id=' + noti.exfields._id);
                    }
                    
                }else{
                    history.push('/voucher/' + code.toLowerCase() + '?_id=' + noti.exfields._id);
                }
              break;
            }
            case "dmgiathitruong":
                history.push({
                    pathname:'/view/dmgiathitruong_agent/' + noti.exfields._id,
                    search:'',
                    state:{previousLocation: this.props.location}
                });
                break;
            case "nhadat":{
                history.push({
                    pathname:`/quickinput/nhadat`,
                    search:`?_id=${noti.exfields._id}`,
                    state:{previousLocation: this.props.location}
                });
                break;
            }

            case "message2":{
                let msg = await this.context.apis.asyncGetData(this.context.getToken(),"message2",{_id:noti.exfields._id});
                if(msg){
                    if(msg.code_link==="okr"){
                        return history.push("/okr/" + msg.id_link +"?tab=2");
                    }
                    if(msg.code_link==="strategicplan"){
                        return history.push("/strategicplan/" + msg.id_link +"?tab=4");
                    }
                    if(msg.code_link==="strategicgoal"){
                        return history.push("/strategicgoal/" + msg.id_link +"?tab=3");
                    }
                    if(msg.code_link==="strategicobjective"){
                        return history.push("/strategicobjective/" + msg.id_link +"?tab=2");
                    }
                    if(msg.code_link==="strategickpi"){
                        return history.push("/strategickpi/" + msg.id_link +"?tab=3");
                    }
                    if(msg.code_link==="keyresult"){
                        return history.push("/keyresult/" + msg.id_link +"?tab=3");
                    }
                    if(msg.code_link==="task"){
                        return history.push("/task/" + msg.id_link +"?tab=2");
                    }
                    if(msg.id_link){
                        console.log("goto to chat",msg);
                        this.context.chat({id_link:msg.id_link});
                    }else{
                        history.push("/chat");
                    }
                }else{
                    setTimeout(()=>{
                        this.context.alert(`${this.context.apis.getLabel("Tin nhắn này đã bị xoá")}`)
                    },0)
                    
                }
                break;
            }
            case "comment":{
                console.log("[Nofitication] xem chi tiết:",noti,this.context.queryParams.for_agent);
                let code_link =  noti.exfields.code_link;
                if(code_link && code_link.toLowerCase()=="nhadat" && this.context.queryParams.for_agent){
                    code_link = "nhadat_agent"
                }
                if(noti.exfields.id_link && code_link){
                    history.push({
                        pathname:`/view/${code_link.toLowerCase()}/${noti.exfields.id_link}`,
                        search:'',
                        state:{previousLocation: this.props.location}
                    });
                }
                break;
            }
            default:{
                console.log("[Nofitication] xem chi tiết:",noti,this.context.queryParams.for_agent);
                if(noti.exfields.id_link && noti.exfields.code_link && !this.context.queryParams.for_agent){
                    history.push({
                        pathname:`/view/${noti.exfields.code_link.toLowerCase()}/${noti.exfields.id_link}`,
                        search:'',
                        state:{previousLocation: this.props.location}
                    });
                }else{
                    history.push('/list/' + code.toLowerCase() + '?_id=' + noti.exfields._id);
                }
                break;
            }
        }
    }
}
export default NotifyProvider;